import React from 'react';
import { useTranslation } from 'react-i18next';
import { EiqInput } from 'eiq-storybook';

import { removeInvalidXmlChars } from 'src/utils/helpers';
import s from 'src/components/CapFieldsNew/CapEditField.styles';

const CapEditInputField = ({
  isEditable,
  name,
  wrapperClassName,
  value,
  onBlur,
  autoFocus = false,
  hasLabel = false,
  label = 'N/A',
  errorMessage
}) => {
  const { t } = useTranslation();

  if (isEditable) {
    return (
      <EiqInput
        type="text"
        name={name}
        autoFocus={autoFocus}
        wrapperClassName={wrapperClassName}
        onBlur={(e) => onBlur(removeInvalidXmlChars(e.target.value))}
        defaultValue={value}
        placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
        errorMessage={errorMessage}
        onFocus={(e) =>
          e.currentTarget.setSelectionRange(
          e.currentTarget.value.length,
          e.currentTarget.value.length
        )}
      />
    );
  }
    
  return <s.Content>{value || (hasLabel && t(label))}</s.Content>;
    
}

export default React.memo(CapEditInputField);
